import { createSlice } from "@reduxjs/toolkit";
import VwHbsYatisDTO from "src/models/HastaKayit/VwHbsYatisDTO";
import VwHbsHastaservisDTO from "src/models/HastaServis/VwHbsHastaservisDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { helper } from "src/utils/helper";


export class YatisKabulSearch {
    baslangicTarih: string = helper.datetimeToday();
    bitisTarih: string = helper.datetimeToday();
    servisId: number;
    doktorId: number;
    muracaatNo: number;
    aciliyetId: number;
    onayDurum: string = "0";
    action: boolean = false;
}
export class YatisKabulModel {
    hbsYatisDTO: VwHbsYatisDTO;
    hbsHastaServisDTO: VwHbsHastaservisDTO;
}

export interface IYatisKabulState {
    filterModel: YatisKabulSearch;
    searchClick: boolean;
}

const YatisKabulSlice = createSlice<IYatisKabulState,
    MapReducerPayloads<IYatisKabulState,
        {
            setFilterModel: YatisKabulSearch;
            setSearchClick: boolean;
        }
    >>({
        name: 'yatiskabul',
        initialState: {
            filterModel: new YatisKabulSearch(),
            searchClick: false
        },
        reducers: {
            setFilterModel: (state, action) => {
                state.filterModel = action.payload;
            },
            setSearchClick: (state, action) => {
                state.searchClick = action.payload;
            }
        }
    });

export default YatisKabulSlice;